import { FirestoreError } from 'firebase/firestore';
import { useEffect } from 'react';

/**
 * Logs Firestore query errors (from react-firebase-hooks) so failures that are
 * otherwise silent — e.g. listeners that error out in in-app browsers — surface
 * in the console and in LogRocket.
 */
export const useLogFirestoreError = (
  query: string,
  error?: FirestoreError,
): void => {
  useEffect(() => {
    if (error) {
      console.error(`Firestore query "${query}" failed`, error);
    }
  }, [query, error]);
};
